import { track } from '@bnnvara/analytics/src/track';
import { BaseButton } from '@bnnvara/buttons';
import { Text } from '@bnnvara/typography';
import Link from 'next/link';
import React from 'react';

import * as S from './styled';

export const MembershipSuccess = () => (
  <S.Wrapper align="center">
    <Text center>
      <br />
      Hartelijk dank voor jouw aanmelding!
    </Text>
    <S.Image
      src="/static/statusImages/donate_success.gif"
      alt="Het lid worden is gelukt"
    />
    <Link href="/" passHref>
      <BaseButton
        fullWidth
        type="link"
        onClick={() => track('lid-worden-gelukt', 'click', 'naar-bnnvara.nl')}
      >
        Ga naar BNNVARA.nl
      </BaseButton>
    </Link>
  </S.Wrapper>
);
